  <template >
  <div>
    <v-overlay :value="isLoading"> <v-progress-circular indeterminate size="64"></v-progress-circular> </v-overlay>
  <div>
  <div class="formPosition">

    <v-data-table    :headers="headers"  :items="estudantes" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

       <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

                 <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title> <span>Matrículas trancadas ou eliminadas</span>
          
            </v-toolbar-title>

          <v-divider class="mx-8" inset vertical></v-divider>

          <!--  search  -->
<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
              v-model="searchInDb"
              append-icon="search"
              label="Pesquisa"

              single-line
              hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <span>Total de Estudantes : <strong style="font-size:20px;" >{{estudantes.length}}</strong>  </span>
          <!-- end  search  -->

        <!-- ============================================================================ -->
           <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Recuperar estudante</v-card-title>
                <v-card-text>Tem a certeza que pretente continuar com operação ? </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="Recuperar()">Continuar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-toolbar>
      </template>
       <!-- <template v-slot:item.action="{ item }">
        <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon color="green darken-3" v-on="on"  class="mr-2" @click="showRecuperar(item)">unarchive</v-icon>
              </template>
              <span>Clique aqui para recuperar o estudante</span>
            </v-tooltip>
      </template> -->

      <template v-slot:item.ord="{ item }">
         <span>{{estudantes.indexOf(item)+1}}</span>
      </template>
      <template v-slot:no-data>
        Clica em + para adicionar novo estudante
      </template>
    </v-data-table>

  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
export default {
  data: () => ({
    isLoading: true,
    searchInDb: '',
    estudantes: [],
    estudanteObj: null,
    dialog: false,    
    headers: [
      { text: 'Ord', value: 'ord' },
      {
        text: 'Actividade',
        align: 'left',
        sortable: false,
        value: 'actividade'
      },

      { text: 'Descrição', value: 'descricao' },
      { text: 'Matricula', value: 'matricula' },
       { text: 'Data da operação', value: 'data_' },
    ],
    editedIndex: -1,
    editedItem: {

      ResidenteEm: 0,
      anoLectivo: '',
      autor: '',
      bi: '',
      certificado: null,
      data_: '',
      dataemissaobi: '',
      datanascimento: '',
      descricao: '',
      email: '',
      emitirCertificado: '',
      emitirCertificadoAutor: '',
      emitirCertificadoData: '',
      emitirCertificadoValidacaoStep: '',
      flag_dados_preparados: null,
      foto: null,
      idCurso: 0,
      idMatricula: '',
      idMunicipio: 0,
      idPEssoa: '',
      idPerfil: 0,
      id_from: 0,
      instituicao: 0,
      instituicaodescricao: '',
      morada: '',
      nome: '',
      nomedamae: '',
      nomedopai: '',
      pkLixeira: 0,
      pkPessoa: 0,
      sexo: '',
      status_2: '',
      tabela_from: '',
      telefone: '',
      trasferidoIN: ''
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    idclasse () {
      return this.$store.state.idclasse
    },
    
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    }

  },

  watch: {
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    async initialize (searchInDb) {
      try {
        if (!searchInDb) {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"all"}'
        } else {
          payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.estudantes = await axios.get('/estudanteFindAll-lixeira').then(res => res.data)
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao estudantes na lixeira' })
      }
    },   

    showRecuperar (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.estudanteObj = item
      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
   
      async Recuperar () {
      try {
        let msg = await axios.post('/estudanteRecuperarById', {params:this.estudanteObj.pkInscricao_na_turma}).then(res => res.data)

          if (msg.affectedRows >= 1) {
            Swal.fire({ icon: 'success', title: 'Informação', text: 'Estudante recuperado com sucesso!' })
            this.estudantes.splice(this.editedIndex, 1)
          }
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Informação', text: 'Ocorreu um erro ao realizar essa operação' })
      } finally {
        this.dialog = false
      }
    }

    // async Recuperar () {
    //   try {
    //     let msg = await axios
    //       .get('/estudanteRecuperarById/' + this.editedItem.id_from + '/' + this.editedItem.tabela_from)
    //       .then(res => res.data)
    //     try {
    //       if (msg.affectedRows >= 1) {
    //         this.text = 'Estudante recuperado com sucesso!'
    //         this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 2000 })
    //         this.estudantes.splice(this.editedIndex, 1)
    //       }
    //     } catch (error) {}
    //     try {
    //       this.text = msg.message.sqlMessage
    //       this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
    //     } catch (error) {}
    //   } catch (error) {
    //     this.text = error.message
    //   } finally {
    //     this.dialog_delete = false
    //   }
    // }



  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
